import { createMutation } from '@tanstack/svelte-query';
import { createInputKey, updateInputKey, deleteInputKey } from '$lib/api/input_key';
import { invalidateAfterInputDeviceUpdate } from '$lib/state/invalidation';
import { getUnitScope, resolveScope, type ScopeFn } from '$lib/queries/scope';
import type { InputKeyRequest, InputKeyResponse } from '$lib/types/input_key';

export const createInputKeyMutation = (scope: ScopeFn = getUnitScope()) =>
  createMutation<InputKeyResponse, Error, InputKeyRequest>(() => ({
    mutationFn: (request) => createInputKey(request),
    onSuccess: () => invalidateAfterInputDeviceUpdate(resolveScope(scope))
  }));

export const updateInputKeyMutation = (scope: ScopeFn = getUnitScope()) =>
  createMutation<InputKeyResponse, Error, { id: number; data: Partial<InputKeyRequest> }>(() => ({
    mutationFn: ({ id, data }) => updateInputKey(id, data),
    onSuccess: () => invalidateAfterInputDeviceUpdate(resolveScope(scope))
  }));

export const deleteInputKeyMutation = (scope: ScopeFn = getUnitScope()) =>
  createMutation<void, Error, number>(() => ({
    mutationFn: (id) => deleteInputKey(id),
    onSuccess: () => invalidateAfterInputDeviceUpdate(resolveScope(scope))
  }));
